export const IS_PROD =
  process.env.IS_PROD === "1" || process.env.NEXT_PUBLIC_IS_PROD === "1"
